import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconFlagAustralia = function IconFlagAustralia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-flag-australia_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#006",
    d: "M0 0h33v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m15.458 19.625-2.253.19.31 2.17-1.553-1.585-1.552 1.585.31-2.17-2.254-.19 1.944-1.115-1.253-1.825 2.114.775.691-2.085.696 2.085 2.114-.775-1.253 1.825zm9.632 2-.546-.79.917.335.3-.905.298.905.918-.335-.541.79.846.485-.98.085.134.945-.67-.695-.681.695.134-.945-.98-.08zM25.085 7.52l-.541-.79.917.335.3-.905.298.905.918-.335-.541.79.846.49-.98.08.134.945-.67-.69-.681.685.134-.94-.98-.08zm-5.45 5.73-.542-.79.918.335.3-.905.303.905.918-.335-.546.79.845.485-.98.085.14.945-.68-.695-.671.695.129-.945-.98-.08zm10.307-1.41-.552-.79.918.335.3-.905.303.905.918-.335-.541.79.84.485-.98.085.135.94-.67-.69-.681.69.134-.94-.98-.085zM27.947 16l-.531.325.15-.595-.48-.39.623-.05.238-.56.242.565.624.045-.48.39.15.595",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006",
    d: "M0 0h16.5v12H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1.934 0 6.29 4.525L14.49 0h2.01v1.55l-6.187 4.475 6.187 4.45V12h-2.062L8.25 7.525 2.088 12H0v-1.5l6.162-4.45L0 1.6V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8102E",
    d: "M10.931 7.025 16.5 11v1L9.513 7.025zm-4.743.5.154.875-4.95 3.6H0zM16.5 0v.075l-6.42 4.7.052-1.1L15.211 0zM0 0l6.162 4.4H4.615L0 1.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.213 0v12h4.125V0zM0 4v4h16.5V4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8102E",
    d: "M0 4.825v2.4h16.5v-2.4zM7.038 0v12h2.475V0z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-flag-australia_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 2a2 2 0 0 1 2-2h29a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
  }))));
};